// app/redux/reducers/missionRequestsReducer.js
import {
    SET_MISSION_REQUEST_LOADING,
    CLEAR_MISSION_REQUEST_MESSAGE,

    GET_MY_MISSION_REQUESTS_SUCCESS,
    GET_MY_MISSION_REQUESTS_FAIL,
    GET_MY_CREATED_MISSION_REQUESTS_SUCCESS,
    GET_MY_CREATED_MISSION_REQUESTS_FAIL,

    GET_MISSION_REQUEST_SUCCESS,
    GET_MISSION_REQUEST_FAIL,

    CREATE_MISSION_REQUEST_SUCCESS,
    CREATE_MISSION_REQUEST_FAIL,

    DUPLICATE_MISSION_REQUEST_SUCCESS,
    DUPLICATE_MISSION_REQUEST_FAIL,

    CANCEL_MISSION_REQUEST_SUCCESS,
    CANCEL_MISSION_REQUEST_FAIL,

    GET_MANAGER_MISSION_INBOX_SUCCESS,
    GET_MANAGER_MISSION_INBOX_FAIL,

    MANAGER_MISSION_DECISION_SUCCESS,
    MANAGER_MISSION_DECISION_FAIL,

    GET_MANAGER_MISSION_HISTORY_SUCCESS,
    GET_MANAGER_MISSION_HISTORY_FAIL,

    GET_ADMIN_MISSION_INBOX_SUCCESS,
    GET_ADMIN_MISSION_INBOX_FAIL,

    ADMIN_MISSION_DECISION_SUCCESS,
    ADMIN_MISSION_DECISION_FAIL,

    GET_ADMIN_MISSION_HISTORY_SUCCESS,
    GET_ADMIN_MISSION_HISTORY_FAIL,

    GET_ALL_MISSION_REQUESTS_SUCCESS,
    GET_ALL_MISSION_REQUESTS_FAIL,

    normalizeError,
} from "../actions/missionRequestActions";

const initialState = {
    myRequests: [],
    myCreatedRequests: [],
    currentRequest: null,
    managerInbox: [],
    managerHistory: [],
    adminInbox: [],
    adminHistory: [],
    allRequests: [],
    loading: false,
    error: null,
    message: null,
    success: false,
};

const toStr = (x) => normalizeError(x, "");

export default function missionRequestsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_MISSION_REQUEST_LOADING:
            return { ...state, loading: !!action.payload };

        case CLEAR_MISSION_REQUEST_MESSAGE:
            return { ...state, error: "", message: "" };

        // ========= MY REQUESTS =========
        case GET_MY_MISSION_REQUESTS_SUCCESS:
            return { ...state, myRequests: action.payload || [], error: "" };

        case GET_MY_MISSION_REQUESTS_FAIL:
            return { ...state, error: toStr(action.payload) };

        case GET_MY_CREATED_MISSION_REQUESTS_SUCCESS:
            return { ...state, myCreatedRequests: action.payload || [], error: "" };

        case GET_MY_CREATED_MISSION_REQUESTS_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= GET SINGLE REQUEST =========
        case GET_MISSION_REQUEST_SUCCESS:
            return { ...state, currentRequest: action.payload, error: "" };

        case GET_MISSION_REQUEST_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= CREATE =========
        case CREATE_MISSION_REQUEST_SUCCESS:
            return {
                ...state,
                message: "Demande de mission envoyée avec succès",
                error: "",
            };

        case CREATE_MISSION_REQUEST_FAIL:
            return { ...state, error: toStr(action.payload) };

        case DUPLICATE_MISSION_REQUEST_SUCCESS:
            return {
                ...state,
                message: "Ordre de mission dupliqué avec succès",
                error: "",
            };

        case DUPLICATE_MISSION_REQUEST_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= CANCEL =========
        case CANCEL_MISSION_REQUEST_SUCCESS:
            return {
                ...state,
                message: "Demande annulée avec succès",
                error: "",
            };

        case CANCEL_MISSION_REQUEST_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= MANAGER INBOX =========
        case GET_MANAGER_MISSION_INBOX_SUCCESS:
            return { ...state, managerInbox: action.payload || [], error: "" };

        case GET_MANAGER_MISSION_INBOX_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= MANAGER DECISION =========
        case MANAGER_MISSION_DECISION_SUCCESS:
            return { ...state, message: "Décision envoyée", error: "" };

        case MANAGER_MISSION_DECISION_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= MANAGER HISTORY =========
        case GET_MANAGER_MISSION_HISTORY_SUCCESS:
            return { ...state, managerHistory: action.payload || [], error: "" };

        case GET_MANAGER_MISSION_HISTORY_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= ADMIN INBOX =========
        case GET_ADMIN_MISSION_INBOX_SUCCESS:
            return { ...state, adminInbox: action.payload || [], error: "" };

        case GET_ADMIN_MISSION_INBOX_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= ADMIN DECISION =========
        case ADMIN_MISSION_DECISION_SUCCESS:
            return { ...state, message: "Décision RH envoyée", error: "" };

        case ADMIN_MISSION_DECISION_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= ADMIN HISTORY =========
        case GET_ADMIN_MISSION_HISTORY_SUCCESS:
            return { ...state, adminHistory: action.payload || [], error: "" };

        case GET_ADMIN_MISSION_HISTORY_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= ADMIN ALL REQUESTS =========
        case GET_ALL_MISSION_REQUESTS_SUCCESS:
            return { ...state, allRequests: action.payload || [], error: "" };

        case GET_ALL_MISSION_REQUESTS_FAIL:
            return { ...state, error: toStr(action.payload) };

        default:
            return state;
    }
}
